export interface SizingModel {
  height: number;
  width: number;
  precision: number;
}
